module.exports = __webpack_public_path__ + "img/logotipo.31ef9c9a.png";